export default __webpack_public_path__ + "static/media/USDT.c1d58766.png";